import { Notification } from "src/features/notifications/types";
import { genericMessages } from "src/messages/generic";

export type NotificationsAction = CreateNotification | CloseNotification;

type CreateNotificationPayload = Omit<Notification, "id" | "timeout">;

interface CreateNotification {
	type: "CREATE_NOTIFICATION";
	payload: CreateNotificationPayload;
}

interface CloseNotification {
	type: "CLOSE_NOTIFICATION";
	payload: { id: number };
}

export function createNotification(
	payload: CreateNotificationPayload
): NotificationsAction {
	return { type: "CREATE_NOTIFICATION", payload };
}

export function closeNotification(id: number): NotificationsAction {
	return { type: "CLOSE_NOTIFICATION", payload: { id } };
}

export function createGenericError(): NotificationsAction {
	return {
		type: "CREATE_NOTIFICATION",
		payload: {
			variant: "error",
			content: genericMessages.somethingWentWrong
		}
	};
}
